import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Seo from '@/components/base/Seo';

export default function About() {
  return (
    <div className="min-h-screen bg-background-50 flex flex-col">
      <Seo
        title="关于我们 - 菠萝蜜网"
        description="了解菠萝蜜网的产品定位、内容范围、法律声明与联系方式，一个专注高清影视资料展示与导航的综合门户平台。"
        keywords="菠萝蜜网,关于我们,网站介绍,联系方式"
      />
      <Navbar />
      <main className="flex-1">
        <div className="bg-primary-950 py-10 md:py-14">
          <div className="max-w-[1000px] mx-auto px-4 md:px-6 text-center">
            <h1 className="text-2xl md:text-4xl font-bold text-background-50">关于菠萝蜜网</h1>
            <p className="mt-3 text-sm md:text-base text-background-300">专注高清影视资讯展示的综合门户平台</p>
          </div>
        </div>

        <div className="max-w-[900px] mx-auto px-4 md:px-6 py-10 md:py-14 space-y-10">
          <section>
            <h2 className="text-xl md:text-2xl font-bold text-foreground-900 mb-3 flex items-center gap-2">
              <i className="ri-information-line text-primary-500"></i> 网站定位
            </h2>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
              菠萝蜜网成立于2024年，是一个专注提供高清电影、电视剧及综艺节目资料信息的综合影视平台。我们面向广泛的影视爱好者及观众群体，
              致力于帮助用户快速查找、浏览和了解各类影视作品信息。网站内容涵盖电影大全、电视剧全集、综艺精选三大核心板块，并通过分类筛选、
              全站搜索、影视专题等功能，为用户提供高效便捷的内容发现体验。我们始终坚持内容丰富、更新及时、导航清晰的产品理念，持续优化用户的浏览体验。
            </p>
          </section>

          <section>
            <h2 className="text-xl md:text-2xl font-bold text-foreground-900 mb-3 flex items-center gap-2">
              <i className="ri-scales-3-line text-primary-500"></i> 法律声明与版权信息
            </h2>
            <div className="bg-background-100 rounded-lg p-5 md:p-6 space-y-3 text-sm text-foreground-700 leading-relaxed">
              <p>1. 本网站所展示的影视作品信息（含海报、简介、演职人员等资料）仅用于内容展示与信息参考，相关版权归原著作权人所有。</p>
              <p>2. 本网站播放区域仅为前端界面演示，不提供任何真实影视播放服务，亦不存储或分发任何影视音视频文件。</p>
              <p>3. 如页面内容涉及版权方权益问题，请通过下方联系方式与我们取得联系，我们将在核实后第一时间处理。</p>
              <p>4. 未经许可，任何单位或个人不得复制、转载本站原创内容用于商业用途。</p>
            </div>
          </section>

          <section>
            <h2 className="text-xl md:text-2xl font-bold text-foreground-900 mb-3 flex items-center gap-2">
              <i className="ri-customer-service-2-line text-primary-500"></i> 联系我们
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
              <div className="bg-background-100 rounded-lg p-5 flex flex-col items-center text-center">
                <i className="ri-mail-send-line text-2xl text-accent-500 mb-2"></i>
                <p className="text-sm text-foreground-500">反馈邮箱</p>
                <p className="text-sm font-medium text-foreground-900 mt-1">contact@boluomiwang.com</p>
              </div>
              <div className="bg-background-100 rounded-lg p-5 flex flex-col items-center text-center">
                <i className="ri-customer-service-line text-2xl text-accent-500 mb-2"></i>
                <p className="text-sm text-foreground-500">在线客服</p>
                <p className="text-sm font-medium text-foreground-900 mt-1">每日 9:00 - 22:00</p>
              </div>
              <div className="bg-background-100 rounded-lg p-5 flex flex-col items-center text-center">
                <i className="ri-map-pin-line text-2xl text-accent-500 mb-2"></i>
                <p className="text-sm text-foreground-500">公司地址</p>
                <p className="text-sm font-medium text-foreground-900 mt-1">示例市示例区影视科技园</p>
              </div>
            </div>
          </section>

          <div className="text-center pt-4">
            <Link
              to="/"
              className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 px-6 py-3 rounded-full text-sm font-medium cursor-pointer whitespace-nowrap"
            >
              <i className="ri-home-5-line"></i> 返回首页
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}